import { AbstractTextHighlighter } from './AbstractTextHighlighter';
import { HighlighterId } from './Highlighter';

export class TextSearchHighlighter extends AbstractTextHighlighter {
  static get id(): HighlighterId {
    return 'textSearchHighlighter';
  }

  get id(): HighlighterId {
    return TextSearchHighlighter.id;
  }
}
